import postAPI from './postAPI.js'

export default async function postInitiateUpload(data) {
    const response = await postAPI('taskinstances/steps/upload/initiate', data);
    return response;
}
